/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { LaunchpadState } from 'state/types'
import { BIG_ZERO } from 'utils/bigNumber'
import fetchLaunchpadOnlyWhitelisted from './fetchLaunchpad'
import fetchLaunchpadIsWhitelisted from './fetchLaunchpadUser'

const initialState: LaunchpadState = {
  data: {
    v1: {
      onlyWhitelisted: true,
      owner: '',
    },
    v2: {
      onlyWhitelisted: true,
      owner: '',
      onlyPayDMD: true,
      onlyPayFTM: true,
      feeFTM: BIG_ZERO,
      feeDMD: BIG_ZERO,
    },
    newCollectionAddress: '',
  },
  userDataLoaded: false,
}

export const fetchLaunchpadPublicDataAsync = () => async (dispatch) => {
  const data = await fetchLaunchpadOnlyWhitelisted()

  dispatch(setLaunchpadPublicData(data))
}

export const fetchLaunchpadUserDataAsync =
  (account: string): any =>
  async (dispatch) => {
    const userData = await fetchLaunchpadIsWhitelisted(account)

    dispatch(setLaunchpadUserData(userData))
  }

export const updateNewCollectionAddress =
  (address: string): any =>
  async (dispatch) => {
    dispatch(setNewCollectionAddress(address))
  }

export const updateLaunchpadV2Data =
  (data): any =>
  async (dispatch) => {
    dispatch(setLaunchpadV2Data(data))
  }

export const updateLaunchpadV2UserData =
  (data): any =>
  async (dispatch) => {
    dispatch(setLaunchpadV2UserData(data))
  }

export const LaunchpadSlice = createSlice({
  name: 'Launchpad',
  initialState,
  reducers: {
    setLaunchpadPublicData: (state, action) => {
      const publicData = action.payload
      state.data = {
        ...state.data,
        ...publicData,
      }
    },
    setLaunchpadUserData: (state, action) => {
      const userData = action.payload
      state.data = {
        ...state.data,
        userData,
      }
      state.userDataLoaded = true
    },
    setNewCollectionAddress: (state, action) => {
      const newCollectionAddress = action.payload
      state.data = {
        ...state.data,
        newCollectionAddress,
      }
    },
    setLaunchpadV2Data: (state, action) => {
      const newV2Data = action.payload
      state.data = {
        ...state.data,
        v2: {
          ...state.data.v2,
          ...newV2Data,
        },
      }
    },
    setLaunchpadV2UserData: (state, action) => {
      const newV2UserData = action.payload
      state.data = {
        ...state.data,
        userData: {
          ...state.data.userData,
          v2: {
            ...state.data.userData.v2,
            ...newV2UserData,
          },
        },
      }
    },
  },
})

// Actions
export const {
  setLaunchpadPublicData,
  setLaunchpadUserData,
  setNewCollectionAddress,
  setLaunchpadV2Data,
  setLaunchpadV2UserData,
} = LaunchpadSlice.actions

export default LaunchpadSlice.reducer
